import { useMemo } from "react"
import axios from "axios"
import { useQuery, UseQueryResult } from "@tanstack/react-query"

import { useAddGlobalToast } from "@app/providers/GlobalToastProvider"
import { BulkLabelPermissions } from "@app/services/types"
import { extractApiErrorMessage } from "@app/utils/extractApiErrorMessage"

export const QUERY_KEY_PREFIX = "BulkLabelPermissions"
const ERROR_TITLE = "Error Loading Permissions"
const ERROR_MESSAGE = "There was an error loading permissions. Contact support if the issue persists."

export const fetchPermissions = async () => {
	return axios
		.get<BulkLabelPermissions>(`skunkworks/bulk-labels/permissions`)
		.then((response) => response.data)
}

export const useGetPermissions = (): UseQueryResult<BulkLabelPermissions, Error> => {
	const addToast = useAddGlobalToast()

	const queryKey = useMemo(() => [QUERY_KEY_PREFIX], [])

	return useQuery({
		queryKey,
		queryFn: () => fetchPermissions(),
		meta: {
			onError: (error: Error) =>
				addToast({
					message: `${ERROR_TITLE}: ${extractApiErrorMessage(error, ERROR_MESSAGE)}`,
					severity: "error",
				}),
		},
	})
}

export default useGetPermissions
